import BookingSettingsTab from './booking-settings';

export default BookingSettingsTab;
